import { Btn } from 'components/Btn'
import { P } from 'components/Typography/P'
import { YouTubeThumb, YouTubeVid } from 'components/YouTube'
import React from 'react'
import styled, { css } from 'styled-components'

export const videoListItemStyles = css`
	.video {
		display: flex;
		margin: 10px 0;
		.thumb {
			p {
				position: absolute;
				right: 5px;
				bottom: -5px;
				color: ${props => props.theme.colors.midNeutral.val};
			}
			img {
				max-width: 150px;
			}
		}
		.info {
			padding-left: 10px;
			text-align: left;
			p {
				color: ${props => props.theme.colors.secondary.val};
				font-size: 1.2rem;
			}
		}
	}
`

const VideoListItemView = styled.div`
	${videoListItemStyles}
`

export type VideoListItemProps = {
	video: YouTubeVid
	onClick?: (Vid: YouTubeVid) => void
}
export const VideoListItem: React.FC<VideoListItemProps> = ({ video, onClick }) => {
	const { length, title, datePosted, tags } = video
	return (
		<VideoListItemView>
			<Btn onClick={() => onClick && onClick(video)}>
				<div className='video'>
					<div className='thumb'>
						<YouTubeThumb video={video} />
						{length ? <P>{length}</P> : null}
					</div>
					<div className='info'>
						<P>{title}</P>
						{tags?.length ? (
							<P>
								{tags?.map((tag, idx) => (
									<span key={idx}>{tag}, </span>
								))}
							</P>
						) : null}
						{datePosted ? <P>{datePosted}</P> : null}
					</div>
				</div>
			</Btn>
		</VideoListItemView>
	)
}
